export const header = {
    "home_page": "Trang Chủ",
    "study_program": "Chương trình học",
    "study_program_sort": "Ctrình học",
    "change_language": "Thay đổi ngôn ngữ",
    "vietnamese": "Tiếng Việt",
    "english": "Tiếng Anh",
};
